/* eslint-disable react/no-array-index-key */
import React, { PropTypes } from 'react';
import classNames from 'classnames';
import {
  composeValidators,
  hasLengthBetween,
  matchesPattern,
} from 'revalidate';
import _isEmpty from 'lodash/isEmpty';
import styles from './PasswordValidationStatus.scss';

const PATTERN_UPPERCASE = /[A-Z]/;
const PATTERN_LOWERCASE = /[a-z]/;
const PATTERN_NUMBER = /[0-9]/;
const PATTERN_SPECIAL = /[^\w\s]|_/;

export const passwordValidators = {
  length: hasLengthBetween(8, 100)({
    message: 'Password must be longer than 8 characters',
  }),
  uppercase: matchesPattern(PATTERN_UPPERCASE)({
    message: 'Password must contain at least one upper-case character',
  }),
  lowercase: matchesPattern(PATTERN_LOWERCASE)({
    message: 'Password must contain at least one lower-case character',
  }),
  number: matchesPattern(PATTERN_NUMBER)({
    message: 'Password must contain at least one number',
  }),
  special: matchesPattern(PATTERN_SPECIAL)({
    message: 'Password must contain at least one special character',
  }),
};

export const isValidPassword = composeValidators(
  passwordValidators.length,
  passwordValidators.uppercase,
  passwordValidators.lowercase,
  passwordValidators.number,
  passwordValidators.special
);

// This is used to get the message from the validator function.
// By sending a faulty value to the validator we can get the text
// from it and dynamically display to the user as long as the validator
// comply with the revalidate validator function spec.
export const passwordInvalidValues = {
  length: 'abc',
  uppercase: 'abc',
  lowercase: 'ABC',
  number: 'abc',
  special: 'abc',
};

const propTypes = {
  value: PropTypes.string.isRequired,
  invalidValues: PropTypes.object,
  validators: PropTypes.object,
  textReplacement: PropTypes.shape({
    pattern: PropTypes.any,
    with: PropTypes.string,
  }),
  className: PropTypes.string,
};

const PasswordValidationStatus = props => {
  const { validators, value, textReplacement } = props;
  const pwdValidators = validators || passwordValidators;
  const list = Object.keys(pwdValidators).reduce((acc, key) => {
    const validationMessage = pwdValidators[key](value);
    const text = pwdValidators[key](passwordInvalidValues[key]);
    let displayText;
    if (textReplacement) {
      displayText = text.replace(textReplacement.pattern, textReplacement.with);
    }
    let isValid = !_isEmpty(value);
    if (validationMessage === text) {
      isValid = false;
    }

    const entry = {
      text,
      isValid,
      displayText,
    };
    acc.push(entry);
    return acc;
  }, []);

  const classes = classNames(styles.root, props.className);
  return (
    <div className={classes}>
      {list.map((obj, i) => {
        return (
          <p
            key={i}
            className={obj.isValid ? styles.ruleValid : styles.ruleInvalid}
          >
            <span className={styles.check} />
            {obj.displayText || obj.text}
          </p>
        );
      })}
    </div>
  );
};

PasswordValidationStatus.propTypes = propTypes;

export default PasswordValidationStatus;



// WEBPACK FOOTER //
// ./src/client/src/components/PasswordValidationStatus.js